import { Box, Rating, Typography } from "@mui/material";

export interface PostReviewMetadata {
  review_text: string;
  review_star_count?: number;
  review_created_sec?: number;
}

export const parseReviewMetadata = (
  metadata: any,
): PostReviewMetadata | null => {
  if (!metadata?.review_text) return null;
  return metadata as PostReviewMetadata;
};

export default ({
  review,
  fontSize = "14px",
}: {
  review: PostReviewMetadata;
  fontSize?: string;
}) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: "6px" }}>
    <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <Rating value={review.review_star_count ?? 5} readOnly size="small" />
      {review.review_created_sec && (
        <Typography variant="bodySmall" color="text.secondary">
          {new Date(review.review_created_sec * 1000).toLocaleDateString(
            undefined,
            { month: "short", day: "numeric", year: "numeric" },
          )}
        </Typography>
      )}
    </Box>
    <Typography
      variant="body"
      color="text.primary"
      sx={{ fontSize, lineHeight: "150%", whiteSpace: "pre-wrap" }}
    >
      {review.review_text}
    </Typography>
  </Box>
);
